import {
  ComponentPropsWithoutRef,
  FC,
  PropsWithChildren,
  forwardRef
} from "react"
import "./Container.scss"

interface ContainerProps extends ComponentPropsWithoutRef<"div"> {
  triangleTopPosLeft?: string | null
  triangleBottomPosLeft?: string | null
  revertTopLeftTriangle?: boolean
  revertBottomLeftTriangle?: boolean
}

type IContainer = PropsWithChildren<ContainerProps>

export const Container = forwardRef<HTMLDivElement, IContainer>(
  (
    {
      children,

      className,
      triangleTopPosLeft = null,
      triangleBottomPosLeft = null,
      revertBottomLeftTriangle,
      revertTopLeftTriangle,

      ...rest
    }: IContainer,
    ref
  ) => {
    return (
      <div ref={ref} className={"container " + className} {...rest}>
        {triangleTopPosLeft && (
          <Triangle
            revert={revertTopLeftTriangle}
            position="top"
            leftValue={triangleTopPosLeft}
          />
        )}
        {children || ""}
        {triangleBottomPosLeft && (
          <Triangle
            revert={revertBottomLeftTriangle}
            position="bottom"
            leftValue={triangleBottomPosLeft}
          />
        )}
      </div>
    )
  }
)

Container.displayName = "Container"

interface TriangleProps {
  position: string
  leftValue: string
  revert?: boolean
}

export const Triangle: FC<TriangleProps> = ({
  position,
  leftValue,
  revert
}) => {
  return (
    <div
      className={"triangle " + position}
      style={{
        left: leftValue,
        transform: revert
          ? position === "top"
            ? "scaleX(1)"
            : "scaleX(-1)"
          : undefined
      }}
    />
  )
}
